import React from 'react';
import './TerraDraw.css';
import { getCenter } from 'geolib';
import { defaultCircleOptions, defaultPolygonOptions, defaultRectangleOptions, } from "../mapsDefaultOptions";

import {
    TerraDraw,
    TerraDrawCircleMode,
    TerraDrawPointMode,
    TerraDrawPolygonMode,
    TerraDrawRectangleMode,
    TerraDrawSelectMode
} from 'terra-draw';
import {TerraDrawGoogleMapsAdapter} from 'terra-draw-google-maps-adapter';
import {getRandomColor} from "../../util/colors";

const modeButtons = {
    'select-mode': 'select',
    'point-mode': 'point',
    'polygon-mode': 'polygon',
    'rectangle-mode': 'rectangle',
    'circle-mode': 'circle',
};

class DrawToolBar extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            activeMode: 'select',
        };
    }

    handleClick = (e) => {
        const selectedMode = modeButtons[e.currentTarget.id];
        this.draw?.setMode(selectedMode);
        this.setState({
            activeMode: selectedMode,
        });

        if(selectedMode !== 'select'){
            this.props.setDrawing(true);
        }

    }

    draw = null;
    map = null;

    sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));


    handleFeatureComplete = (feature) => {
        switch (feature.properties.mode ) {
            case 'polygon':
                this.handleNewPolygon(feature);
                break;
            case 'point':
                this.handleNewPoint(feature);
                break;
            case 'rectangle':
                this.handleNewRectangle(feature);
                break;
            case 'circle':
                this.handleNewCircle(feature);
                break;
            default:
                console.log('Feature created with coordinates:', feature.geometry.coordinates);

        }
    }

    async componentDidMount() {

        await this.sleep(2000);

        const map = window?.googleMap?.context?.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

        if(!map) return;

        this.map = map;


        this.map.data.setStyle(function(feature) {
            return {
                zIndex: 9999999
            };
        });

        this.draw = new TerraDraw({
            adapter: new TerraDrawGoogleMapsAdapter({
                map,
                lib: window.google.maps,
                coordinatePrecision: 9,
                ignoreMismatchedPointerEvents: true,
            }),
            modes: [
                new TerraDrawSelectMode({
                    flags: {
                        polygon: {
                            feature: {
                                draggable: false,
                                rotateable: false,
                                coordinates: {
                                    midpoints: true,
                                    draggable: true,
                                    deletable: true,
                                },
                            },
                        },
                        point: {
                            feature: {
                                draggable: true,
                                rotateable: true,
                            },
                        },
                        rectangle: {
                            feature: {
                                draggable: true,
                                rotateable: true,
                                coordinates: {
                                    midpoints: true,
                                    draggable: true,
                                    deletable: true,
                                },
                            },
                        },
                        circle: {
                            feature: {
                                draggable: true,
                                rotateable: true,
                                coordinates: {
                                    midpoints: true,
                                    draggable: true,
                                    deletable: true,
                                },
                            },
                        },
                    },
                }),
                new TerraDrawPointMode({
                    editable: true,
                    styles: { pointColor: getRandomColor() },
                }),
                new TerraDrawPolygonMode({
                    editable: true,
                    styles: (() => {
                        const color = getRandomColor();

                        return {
                            fillColor: color,
                            outlineColor: '#000000',
                            zIndex: 90
                        };
                    })(),
                }),
                new TerraDrawRectangleMode({
                    styles: (() => {
                        const color = getRandomColor();

                        return {
                            fillColor: color,
                            outlineColor: '#000000',
                        };
                    })(),
                }),
                new TerraDrawCircleMode({
                    drawInteraction: "click-drag",
                    pointerDistance: 12,
                    zIndex: 999999,
                    styles: (() => {
                        const color = getRandomColor();

                        return {
                            fillColor: color,
                            outlineColor: '#000000',

                        };
                    })(),
                }),
            ],
        });

        this.draw.start();

        this.draw.on('ready', () => {
            this.draw.setMode('select');
        });

        this.draw.on('finish', (id) => {
            const snapshot = this.draw.getSnapshot();
            const feature = snapshot.find(f => f.id === id);
            this.handleFeatureComplete(feature);
            this.draw.clear();
            this.draw.setMode('select');
            this.props.setDrawing(false);
        });
    }

    render(){
        return (
            <React.Fragment>
                <div id="mode-ui">
                    <button id="select-mode" onClick={this.handleClick} className={`mode-button ${this.state.activeMode === 'select' ? 'active' : ''}`} title="Selecionar">
                        <img src="/img/terra-draw/select.svg" alt="Selecionar" draggable="false"/>
                    </button>
                    <button id="point-mode" onClick={this.handleClick} className={`mode-button ${this.state.activeMode === 'point' ? 'active' : ''}`} title="Marcador">
                        <img src="/img/terra-draw/point.svg" alt="Point" draggable="false"/>
                    </button>
                    <button id="polygon-mode" onClick={this.handleClick} className={`mode-button ${this.state.activeMode === 'polygon' ? 'active' : ''}`} title="Polígono">
                        <img src="/img/terra-draw/polygon.png" alt="Polygon" draggable="false"/>
                    </button>
                    <button id="rectangle-mode" onClick={this.handleClick} className={`mode-button ${this.state.activeMode === 'rectangle' ? 'active' : ''}`} title="Retângulo">
                        <img src="/img/terra-draw/rectangle.svg" alt="Rectangle" draggable="false"/>
                    </button>
                    <button id="circle-mode" onClick={this.handleClick} className={`mode-button ${this.state.activeMode === 'circle' ? 'active' : ''}`} title="Círculo">
                        <img src="/img/terra-draw/circle.svg" alt="Circle" draggable="false"/>
                    </button>
                </div>

            </React.Fragment>
        )
    };

    handleNewCircle(feature) {

        const radius = feature.properties.radiusKilometers * 1000; // em metros
        const coordinates = feature.geometry.coordinates[0].map( coord => ({ latitude: coord[1], longitude: coord[0] }) );

        const center = getCenter(coordinates);


        const circle = new google.maps.Circle({
            ...defaultCircleOptions,
            center: { lat: center.latitude, lng: center.longitude },
            radius: radius,
        })

        circle.setMap(this.map);


        if (this.props.onCircleComplete) {
            this.props.onCircleComplete(circle);
        }

    }

    handleNewPolygon(feature) {
        const coordinates = feature.geometry.coordinates[0].map(coord => ({
            lat: coord[1],
            lng: coord[0]
        }));

        console.log('Polígono criado:', coordinates);

        if (this.props.onPolygonComplete) {
            const polygon = new google.maps.Polygon({
                ...defaultPolygonOptions,
                paths: coordinates,
            });

            polygon.setMap(this.map);

            this.props.onPolygonComplete(polygon);
        }

    }

    handleNewPoint(feature) {
        const coordinates = {
            lat: feature.geometry.coordinates[1],
            lng: feature.geometry.coordinates[0]
        };

        if (this.props.onMarkerComplete) {
            const marker = new google.maps.Marker({
                position: coordinates,
            });

            marker.setMap(this.map);

            this.props.onMarkerComplete(marker);
        }

    }


    handleNewRectangle(feature) {
        const coordinates = feature.geometry.coordinates[0].map(coord => ({
            lat: coord[1],
            lng: coord[0]
        }));

        if (this.props.onRectangleComplete) {
            const bounds = new google.maps.LatLngBounds();
            coordinates.forEach(coord => bounds.extend(coord));

            const rectangle = new google.maps.Rectangle({
                ...defaultRectangleOptions,
                bounds: bounds,
            });

            rectangle.setMap(this.map);
            this.props.onRectangleComplete(rectangle);
        }
    }
}

export default DrawToolBar;
